import S from "./Divider.module.scss";

interface DividerProps {
  imageSrc: string;
  alt?: string;
}

export const Divider = ({ imageSrc, alt = "divider image" }: DividerProps) => {
  return (
    <div className={S.dividerRoot}>
      <div className={S.dividerInner}>
        <div className={S.dividerIcon}>
          <img src={imageSrc} alt={alt} className={S.image} />
        </div>
      </div>
    </div>
  );
};
